import { render, staticRenderFns } from "./c-content-text-bars@.vue?vue&type=template&id=2a1c7350&scoped=true&"
import script from "./c-content-text-bars@.vue?vue&type=script&lang=ts&"
export * from "./c-content-text-bars@.vue?vue&type=script&lang=ts&"
import style0 from "./c-content-text-bars@.vue?vue&type=style&index=0&id=2a1c7350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c7350",
  null
  
)

export default component.exports